module.exports = __webpack_public_path__ + "img/faq12.d1def80e.png";